import VSwipeLeft from '@/directives/VSwipeLeft';
import VSwipeRight from '@/directives/VSwipeRight';

export default [
    VSwipeLeft,
    VSwipeRight
]